<template>
  <div class="radio">
    <input
      ref="radioBtn"
      :id="id"
      name="radio"
      type="radio"
      :checked="checked"
      :value="value"
      @input="handleBtnCheck"
    />
    <label
      :for="id"
      class="radio-label"
    >
      <!-- :style="style" -->
      <slot></slot>
      {{ text }}
    </label>
  </div>
</template>

<script>
export default {
  props: {
    text: { type: String },
    id: { type: [String, Number], default: "radio-1" },
    value: { type: [String, Number,Boolean] },
    checked : { type : Boolean, default : false}
    // width: { type: Number, default: 1.4 },
    // height: { type: Number, default: 1.4 }
  },
      mounted(){
       if(this.checked) this.$emit('input',this.id)
    },
  // computed : {
  //   style(){
  //     return {
  //       '--width' : this.width && typeof(width) == 'number' ? this.width + 'em' : '1.4em',
  //       '--height' : this.height + 'em'
  //     }
  //   }
  // },
  methods: {
    handleBtnCheck(event) {
      this.$emit("handlebtncheck", event.target);
      this.$emit("input", event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
$color1: #f4f4f4;
$color2: #5fa8d3;

.radio {
  margin: 0.5rem;
  .radio-label {
    display: flex;
  }
  input[type="radio"] {
    position: absolute;
    opacity: 0;
    + .radio-label {
      &:before {
        content: "";
        background: $color1;
        border-radius: 100%;
        border: 1px solid darken($color1, 25%);
        display: inline-block;
        width: 1.3rem;
        height: 1.3rem;
        position: relative;
        top: 0;
        margin-right: .5rem;
        vertical-align: top;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
        align-self: center;
      }
    }
    &:checked {
      + .radio-label {
        &:before {
          background-color: $color2;
          box-shadow: inset 0 0 0 4px $color1;
        }
      }
    }
    &:focus {
      + .radio-label {
        &:before {
          outline: none;
          border-color: $color2;
        }
      }
    }
    &:disabled {
      + .radio-label {
        &:before {
          box-shadow: inset 0 0 0 4px $color1;
          border-color: darken($color1, 25%);
          background: darken($color1, 25%);
        }
      }
    }
    + .radio-label {
      &:empty {
        &:before {
          margin-right: 0;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/global/RadioButton.vue